<template>
  <v-card>
    <v-card-title>Anticipated Contract Amount</v-card-title>
    <v-card-text class="title">
      <v-progress-circular :value="20" :indeterminate="true" v-if="payment_amount == null"></v-progress-circular>
      <span v-else>${{ payment_amount | formatCurrency }}</span>
    </v-card-text>
  </v-card>
</template>

<script>
import firebase from 'firebase/app'
import 'firebase/functions'

export default {
  props: {
    assignment_data: Object
  },
  data() {
    return {
      payment_amount: null
    }
  },
  filters: {
    formatCurrency(amount) {
      return parseInt(amount).toFixed(2)
    }
  },
  mounted() {
    const vm = this
    const getOpusApi = firebase.functions().httpsCallable('getOpusApi')

    if(vm.assignment_data.performance_site) {
      const site_id = vm.assignment_data.performance_site.id
      getOpusApi({
        table: `performance_slot_utilization_news/${site_id}`
      }).then(function(response) {
        // console.log(response)
        vm.payment_amount = response.data.result.rec_eng_total_payment
      })
    }
    else {
      vm.payment_amount = 0
    }
  }
}
</script>